// GENERATED by `pnpm --filter @dosfilos/functions gen:dispatch-map` — do not edit.
// Source: apps/functions/src/dispatch/registries.ts (one line per migrated context).
// An action listed here is called through its dispatcher; any other callable
// name still goes to its own function.
export const DISPATCH_MAP: Readonly<Record<string, string>> = {
  acceptAdmission: 'admissionsDispatch',
  addCreditAdjustment: 'paymentsDispatch',
  addSession: 'syllabusDispatch',
  adjustPayment: 'paymentsDispatch',
  admissionApplicantDocumentUrl: 'admissionsDispatch',
  applyAdminScholarshipGrant: 'paymentsDispatch',
  applyForScholarship: 'paymentsDispatch',
  applyTuitionDiscount: 'paymentsDispatch',
  applyTuitionExemption: 'paymentsDispatch',
  approveSeminaryRequest: 'platformDispatch',
  approveStandard: 'academicsDispatch',
  archiveSurveyTemplate: 'surveysDispatch',
  assignProgramScholarship: 'paymentsDispatch',
  assistantDeleteChat: 'capDispatch',
  assistantHistory: 'capDispatch',
  assistantListChats: 'capDispatch',
  assistantOpenChat: 'capDispatch',
  auditProgramEnrollments: 'platformDispatch',
  cancelCampaign: 'crmDispatch',
  capAssembleProposal: 'capDispatch',
  capBuildAlignmentMatrix: 'capDispatch',
  capDefineOutcomes: 'capDispatch',
  capGetNonAcademicAttestations: 'capDispatch',
  capGetProposal: 'capDispatch',
  capListComplianceSnapshots: 'capDispatch',
  capPresentProposal: 'capDispatch',
  capReopenProposal: 'capDispatch',
  capRunComplianceAudit: 'capDispatch',
  capSaveComplianceSnapshot: 'capDispatch',
  capSaveProposal: 'capDispatch',
  capSetAlignmentMarks: 'capDispatch',
  capSetNonAcademicAttestation: 'capDispatch',
  capSubmitProposalToNetwork: 'capDispatch',
  capTagSignatureAssignment: 'capDispatch',
  capTransitionProposal: 'capDispatch',
  capUpdateOutcome: 'capDispatch',
  capUpsertCcd: 'capDispatch',
  changeEnrollmentSection: 'admissionsDispatch',
  changeProgramWithEnrollmentTransition: 'admissionsDispatch',
  changeStudentPaymentPlan: 'paymentsDispatch',
  checkInviteToken: 'platformDispatch',
  closeGrade: 'academicsDispatch',
  closeSectionGradebook: 'academicsDispatch',
  closeSocraticSession: 'assignmentsDispatch',
  closeSurvey: 'surveysDispatch',
  completeAdmissionForm: 'admissionsDispatch',
  completeInviteActivation: 'platformDispatch',
  configureZoomIntegration: 'engagementDispatch',
  convertCrmContactToPerson: 'admissionsDispatch',
  countCampaignAudience: 'crmDispatch',
  countUnreadNotifications: 'engagementDispatch',
  createAdmission: 'admissionsDispatch',
  createAssignment: 'assignmentsDispatch',
  createCourse: 'academicsDispatch',
  createCourseMaterial: 'lmsDispatch',
  createCourseTemplate: 'syllabusDispatch',
  createCrmContact: 'crmDispatch',
  createDepartment: 'academicsDispatch',
  createFormTemplate: 'academicsDispatch',
  createJournalEntry: 'engagementDispatch',
  createLmsModule: 'lmsDispatch',
  createModuleItem: 'lmsDispatch',
  createMyMentorSession: 'engagementDispatch',
  createPage: 'lmsDispatch',
  createPerson: 'admissionsDispatch',
  createPrayerRequest: 'engagementDispatch',
  createProgram: 'academicsDispatch',
  createProgramEnrollment: 'academicsDispatch',
  createQuiz: 'assignmentsDispatch',
  createScholarship: 'paymentsDispatch',
  createSection: 'academicsDispatch',
  createSurveyTemplate: 'surveysDispatch',
  createTerm: 'academicsDispatch',
  createTextbook: 'syllabusDispatch',
  decideSyllabusProposal: 'syllabusDispatch',
  deleteAdmission: 'admissionsDispatch',
  deleteAssignment: 'assignmentsDispatch',
  deleteCampaignDraft: 'crmDispatch',
  deleteCourse: 'academicsDispatch',
  deleteCourseMaterial: 'lmsDispatch',
  deleteCourseTemplate: 'syllabusDispatch',
  deleteCrmContact: 'crmDispatch',
  deleteDepartment: 'academicsDispatch',
  deleteFormTemplate: 'academicsDispatch',
  deleteJournalEntry: 'engagementDispatch',
  deleteLmsModule: 'lmsDispatch',
  deleteModuleItem: 'lmsDispatch',
  deleteMyMentorSession: 'engagementDispatch',
  deletePage: 'lmsDispatch',
  deletePayment: 'paymentsDispatch',
  deletePrayerRequest: 'engagementDispatch',
  deleteProgram: 'academicsDispatch',
  deleteSection: 'academicsDispatch',
  deleteSurvey: 'surveysDispatch',
  deleteTerm: 'academicsDispatch',
  deleteTextbook: 'syllabusDispatch',
  deleteTuitionPlan: 'paymentsDispatch',
  disconnectMercadoPago: 'paymentsDispatch',
  dropEnrollment: 'admissionsDispatch',
  duplicateCourseTemplate: 'syllabusDispatch',
  editSession: 'syllabusDispatch',
  enrollStudent: 'admissionsDispatch',
  enrollStudentInTerm: 'admissionsDispatch',
  generateSyllabus: 'syllabusDispatch',
  generateTermSections: 'academicsDispatch',
  getAcademicAnalytics: 'academicsDispatch',
  getActaDraft: 'academicsDispatch',
  getAdmissionByToken: 'admissionsDispatch',
  getAnalyticsPeople: 'academicsDispatch',
  getAssignmentRubric: 'assignmentsDispatch',
  getAssistedReviews: 'assignmentsDispatch',
  getBrandingByTenantId: 'platformDispatch',
  getCapacityReport: 'academicsDispatch',
  getCourseMaterialDownloadUrl: 'lmsDispatch',
  getCourseTemplatePrevious: 'syllabusDispatch',
  getCredentialProgress: 'academicsDispatch',
  getDegreeAudit: 'academicsDispatch',
  getMercadoPagoConnectUrl: 'paymentsDispatch',
  getMercadoPagoIntegrationState: 'paymentsDispatch',
  getMyCalendarFeedToken: 'syllabusDispatch',
  getMyMentorPairing: 'engagementDispatch',
  getMyScholarshipStatus: 'paymentsDispatch',
  getNotificationPreferences: 'engagementDispatch',
  getOpenTermsForStudent: 'admissionsDispatch',
  getOrCreateDraftSubmission: 'assignmentsDispatch',
  getPage: 'lmsDispatch',
  getPaymentInstructions: 'paymentsDispatch',
  getPracticeTrajectory: 'assignmentsDispatch',
  getProgramWithdrawalPreview: 'academicsDispatch',
  getQuizForEdit: 'assignmentsDispatch',
  getQuizForStudent: 'assignmentsDispatch',
  getQuizReview: 'assignmentsDispatch',
  getReportsOverview: 'academicsDispatch',
  getSectionAttendanceMatrix: 'engagementDispatch',
  getSectionAttendanceSummary: 'engagementDispatch',
  getSectionCalendar: 'syllabusDispatch',
  getSectionGradebook: 'academicsDispatch',
  getSectionPerformance: 'academicsDispatch',
  getSectionRecipientCount: 'surveysDispatch',
  getSectionsForPortal: 'admissionsDispatch',
  getSectionStructure: 'lmsDispatch',
  getSectionSyllabus: 'syllabusDispatch',
  getSectionWorkDetail: 'academicsDispatch',
  getSessionAttendance: 'engagementDispatch',
  getStandardForEdit: 'academicsDispatch',
  getStudentCourseSessions: 'engagementDispatch',
  getStudentCourseSyllabus: 'syllabusDispatch',
  getStudentFollowUp: 'academicsDispatch',
  getStudentGrowth: 'assignmentsDispatch',
  getStudentPaymentSummary: 'paymentsDispatch',
  getSubmission: 'assignmentsDispatch',
  getSubmissionFileUrl: 'assignmentsDispatch',
  getSurveyAnalytics: 'surveysDispatch',
  getSurveyAutomation: 'surveysDispatch',
  getSurveyBenchmark: 'surveysDispatch',
  getSurveyDiagnostics: 'surveysDispatch',
  getSurveyForStudent: 'surveysDispatch',
  getSurveyOverview: 'surveysDispatch',
  getTeachingCoverage: 'academicsDispatch',
  getTenantDetail: 'platformDispatch',
  getTermSectionsOverview: 'academicsDispatch',
  getUserActivity: 'platformDispatch',
  getZoomIntegrationState: 'engagementDispatch',
  gradeAbsentStudent: 'assignmentsDispatch',
  gradeAllAbsentStudents: 'assignmentsDispatch',
  gradeSubmission: 'assignmentsDispatch',
  grantGroupAccess: 'admissionsDispatch',
  hardDeletePerson: 'admissionsDispatch',
  hardDeleteSection: 'academicsDispatch',
  hardDeleteTerm: 'academicsDispatch',
  inviteApplicant: 'admissionsDispatch',
  inviteUser: 'platformDispatch',
  launchSurvey: 'surveysDispatch',
  listAssignmentGradingRoster: 'assignmentsDispatch',
  listAssignmentSocraticSessions: 'assignmentsDispatch',
  listCampaigns: 'crmDispatch',
  listGraduationCandidates: 'academicsDispatch',
  listModuleSessions: 'syllabusDispatch',
  listMyAnnouncements: 'admissionsDispatch',
  listMyItemViews: 'lmsDispatch',
  listMyJournal: 'engagementDispatch',
  listMyMentorSessions: 'engagementDispatch',
  listNotifications: 'engagementDispatch',
  listOpenSurveysForStudent: 'surveysDispatch',
  listPlatformAuditEvents: 'platformDispatch',
  listPracticeStudents: 'assignmentsDispatch',
  listPrayerRequests: 'engagementDispatch',
  listProgramCohort: 'academicsDispatch',
  listProgramScholarshipAwards: 'paymentsDispatch',
  listScaffolds: 'academicsDispatch',
  listScholarshipApplications: 'paymentsDispatch',
  listSectionAssignments: 'assignmentsDispatch',
  listSectionMaterials: 'lmsDispatch',
  listSectionRoster: 'academicsDispatch',
  listSectionSessions: 'syllabusDispatch',
  listSeminaryRequests: 'platformDispatch',
  listStandards: 'academicsDispatch',
  listStudentProgramEnrollments: 'academicsDispatch',
  listStudents: 'academicsDispatch',
  listSurveysForSection: 'surveysDispatch',
  listSurveyTemplates: 'surveysDispatch',
  listSyllabusProposals: 'syllabusDispatch',
  listTenantInvites: 'platformDispatch',
  logImpersonation: 'platformDispatch',
  markAllNotificationsRead: 'engagementDispatch',
  markItemViewed: 'lmsDispatch',
  markNotificationRead: 'engagementDispatch',
  markPrayerAnswered: 'engagementDispatch',
  markProgramGraduated: 'academicsDispatch',
  markSessionAttendance: 'engagementDispatch',
  membershipAssemblePacket: 'capDispatch',
  membershipBuildRosterAnnex: 'capDispatch',
  membershipDeleteEvidence: 'capDispatch',
  membershipEvidenceDownloadUrl: 'capDispatch',
  membershipGetProfile: 'capDispatch',
  membershipGetReadiness: 'capDispatch',
  membershipListAttestations: 'capDispatch',
  membershipListCriterionStatuses: 'capDispatch',
  membershipListEvidence: 'capDispatch',
  membershipListSubmissions: 'capDispatch',
  membershipRecordAttestation: 'capDispatch',
  membershipRunReadiness: 'capDispatch',
  membershipSetCriterionStatus: 'capDispatch',
  membershipSetStage: 'capDispatch',
  membershipSubmitToNetwork: 'capDispatch',
  membershipUpsertEvidence: 'capDispatch',
  membershipWithdrawSubmission: 'capDispatch',
  moveDayToModule: 'syllabusDispatch',
  moveSessionDate: 'syllabusDispatch',
  moveSessionToModule: 'syllabusDispatch',
  networkDecideCapSubmission: 'capDispatch',
  networkDecideSubmission: 'capDispatch',
  networkGetCapSubmissionDetail: 'capDispatch',
  networkGetSubmissionDetail: 'capDispatch',
  networkListCapAnalyses: 'capDispatch',
  networkListCapSubmissions: 'capDispatch',
  networkListSubmissions: 'capDispatch',
  networkRevokeCapCertification: 'capDispatch',
  networkRevokeSeminaryStage: 'capDispatch',
  openPortalView: 'academicsDispatch',
  previewSyllabusDates: 'syllabusDispatch',
  previewSyllabusRegeneration: 'syllabusDispatch',
  proposeSyllabusChange: 'syllabusDispatch',
  provisionPersonAccess: 'admissionsDispatch',
  publishAssignment: 'assignmentsDispatch',
  publishLmsModule: 'lmsDispatch',
  recordGrade: 'academicsDispatch',
  recordSurveyAction: 'surveysDispatch',
  redeemInviteToken: 'platformDispatch',
  regenerateMyCalendarFeedToken: 'syllabusDispatch',
  registerPushToken: 'engagementDispatch',
  rejectAdmission: 'admissionsDispatch',
  rejectAdmissionDocument: 'admissionsDispatch',
  rejectSeminaryRequest: 'platformDispatch',
  remindSurveyNonRespondents: 'surveysDispatch',
  removeMember: 'platformDispatch',
  removeSession: 'syllabusDispatch',
  reopenSectionGradebook: 'academicsDispatch',
  reopenSubmission: 'assignmentsDispatch',
  reorderLmsModules: 'lmsDispatch',
  reorderModuleItems: 'lmsDispatch',
  resendBulkWelcomeEmail: 'admissionsDispatch',
  resendInvite: 'platformDispatch',
  resendStudentWelcomeEmail: 'admissionsDispatch',
  resendTenantInvite: 'platformDispatch',
  resetAdmissionToDraft: 'admissionsDispatch',
  resolveInviteTokenBranding: 'platformDispatch',
  restoreCourseTemplatePrevious: 'syllabusDispatch',
  returnSubmissionForRevision: 'assignmentsDispatch',
  reviewScholarshipApplication: 'paymentsDispatch',
  revokeProgramScholarship: 'paymentsDispatch',
  revokeZoomIntegration: 'engagementDispatch',
  saveActaDraft: 'academicsDispatch',
  saveCampaignDraft: 'crmDispatch',
  saveGrowthOverride: 'assignmentsDispatch',
  savePracticeQuestions: 'academicsDispatch',
  saveQuizDraft: 'assignmentsDispatch',
  saveSocraticConfig: 'assignmentsDispatch',
  saveSocraticTeacherNote: 'assignmentsDispatch',
  saveSubmissionAnnotations: 'assignmentsDispatch',
  scheduleCampaign: 'crmDispatch',
  seedStandardSurveyTemplates: 'surveysDispatch',
  seedStarterContent: 'platformDispatch',
  selfMarkAttendance: 'engagementDispatch',
  sendCampaign: 'crmDispatch',
  sendSurveyTestEmail: 'surveysDispatch',
  sendTestCampaign: 'crmDispatch',
  setDayModality: 'engagementDispatch',
  setItemCompleted: 'lmsDispatch',
  setProgramEnrollmentLeave: 'academicsDispatch',
  setProgramLadderRules: 'academicsDispatch',
  setProgramMinAttendance: 'academicsDispatch',
  setSectionLifecycle: 'academicsDispatch',
  setSurveyAutomation: 'surveysDispatch',
  setSyllabusContentOverride: 'syllabusDispatch',
  setTenantModules: 'platformDispatch',
  setTenantPlatformFlag: 'platformDispatch',
  setTenantStatus: 'platformDispatch',
  setZoomCourseHost: 'engagementDispatch',
  softDeletePerson: 'admissionsDispatch',
  startAdmissionReview: 'admissionsDispatch',
  startPracticeSession: 'assignmentsDispatch',
  startSocraticSession: 'assignmentsDispatch',
  submitAdmission: 'admissionsDispatch',
  submitAdmissionDocuments: 'admissionsDispatch',
  submitPaymentReceipt: 'paymentsDispatch',
  submitQuiz: 'assignmentsDispatch',
  submitReviewVote: 'admissionsDispatch',
  submitSubmission: 'assignmentsDispatch',
  submitSurveyResponse: 'surveysDispatch',
  syncZoomRecordingsForTenant: 'engagementDispatch',
  togglePrayerPray: 'engagementDispatch',
  unregisterPushToken: 'engagementDispatch',
  updateAssignment: 'assignmentsDispatch',
  updateCourse: 'academicsDispatch',
  updateCourseMaterial: 'lmsDispatch',
  updateCourseTemplate: 'syllabusDispatch',
  updateCrmContact: 'crmDispatch',
  updateDepartment: 'academicsDispatch',
  updateFormTemplate: 'academicsDispatch',
  updateJournalEntry: 'engagementDispatch',
  updateLmsModule: 'lmsDispatch',
  updateMembershipPersonLink: 'platformDispatch',
  updateMembershipRoles: 'platformDispatch',
  updateModuleDayDate: 'syllabusDispatch',
  updateModuleItem: 'lmsDispatch',
  updateMyMentorPairing: 'engagementDispatch',
  updateMyMentorSession: 'engagementDispatch',
  updateNotificationPreferences: 'engagementDispatch',
  updatePage: 'lmsDispatch',
  updatePerson: 'admissionsDispatch',
  updateProgram: 'academicsDispatch',
  updateQuiz: 'assignmentsDispatch',
  updateReviewVote: 'admissionsDispatch',
  updateSection: 'academicsDispatch',
  updateStudentEmail: 'admissionsDispatch',
  updateSubmissionDraft: 'assignmentsDispatch',
  updateSurveyTemplate: 'surveysDispatch',
  updateTenantConfig: 'platformDispatch',
  updateTerm: 'academicsDispatch',
  updateTextbook: 'syllabusDispatch',
  updateTuitionPlanInstallments: 'paymentsDispatch',
  verifyAdmissionDocument: 'admissionsDispatch',
  verifyPayment: 'paymentsDispatch',
  waitlistAdmission: 'admissionsDispatch',
  withdrawFromProgram: 'academicsDispatch',
  withdrawStudent: 'admissionsDispatch',
  withdrawStudentPreview: 'admissionsDispatch',
};
